<template>
  <div class="museum mp-wrapper">
    <Navigation />
    <!-- <div class="margin-left"></div> -->
    <div
      class="mp-container"
    >
      <div class="content ">
        <h1
        >Herzlich willkommen</h1>
        <h2
        >im Museum Pankow, Standort Heynstr. 8</h2>
        <img 
          src="/img/treppenhaus.jpg"
          alt="Treppenhaus im Museum Pankow"
        >
        <div v-html="home.content" />
      </div>
    </div>
    <!-- <div class="margin-right">right</div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import Navigation from '@/components/Navigation'

export default {
  name: 'home',
  components: {
    Navigation
  },
  data () {
    return {

    }
  },
  methods: {
    
  },
  computed: {
    ...mapGetters({
      selectedVideo: 'getSelectedVideo',
      player: 'getPlayerStatus',
      pagesData: 'getPagesData',
      home: 'getHomepageData'
    })
  },
  created () {
    this.$store.state.selectedVideo = null
  }
}
</script>
<style lang="scss" scoped>
  @import '@/scss/custom.scss';
  .museum {
    position: relative;
    min-height: 100vh;
    .content {
      background-color: $sand-dark-80;
      margin: 6rem 12rem 0rem 4rem;
      padding: 4rem 4rem;
      font-size: $font-text-md;
      line-height: 1.8;
      img {
        display: block;
        float: right;
        margin: 0 0 1rem 1rem;
        max-width: 40%;
      }
      h1, h2 {
        font-family: 'Tangerine', serif;
        font-weight: 700;
        font-size: 4.4rem;
        color: $red-light;
        margin: 0;
      }
      h2 {
        font-size: 2.8rem;
        font-weight: 400;
        margin: 0 0 1.2rem 0;
      }
    }
  }
</style>